import type { Candle } from '../../types/market.js';

export function finite(values: number[]): number[] {
  return values.filter(Number.isFinite);
}

export function standardDeviation(values: number[]): number {
  if (values.length === 0) return 0;
  const mean = values.reduce((sum, value) => sum + value, 0) / values.length;
  const variance = values.reduce((sum, value) => sum + (value - mean) ** 2, 0) / values.length;
  return Math.sqrt(variance);
}

export function pivotIndices(values: number[], lookback = 3): number[] {
  const pivots: number[] = [];
  for (let i = lookback; i < values.length - lookback; i += 1) {
    const value = values[i];
    if (!Number.isFinite(value)) continue;
    let low = true;
    let high = true;
    for (let j = i - lookback; j <= i + lookback; j += 1) {
      if (j === i) continue;
      const other = values[j];
      if (other === undefined || value === undefined || !Number.isFinite(other)) continue;
      if (other <= value) low = false;
      if (other >= value) high = false;
    }
    if (low || high) pivots.push(i);
  }
  return pivots;
}

export function lastTwoPivots(values: number[], kind: 'low' | 'high', lookback = 3): [number, number] | null {
  const pivots: number[] = [];
  for (let i = lookback; i < values.length - lookback; i += 1) {
    const value = values[i];
    if (!Number.isFinite(value)) continue;
    let valid = true;
    for (let j = i - lookback; j <= i + lookback; j += 1) {
      if (j === i) continue;
      const other = values[j];
      if (other === undefined || value === undefined || !Number.isFinite(other)) continue;
      if (kind === 'low' && other < value) { valid = false; break; }
      if (kind === 'high' && other > value) { valid = false; break; }
    }
    if (valid) pivots.push(i);
  }
  if (pivots.length < 2) return null;
  return [pivots[pivots.length - 2]!, pivots[pivots.length - 1]!];
}

export function typicalPrice(candle: Candle): number {
  return (candle.high + candle.low + candle.close) / 3;
}
